export default {
  setActiveStepForm (state, data) {
    state.activeStepForm = data
  },
  SET_LINKS (state, links) {
    state.allLinks = links
  }
}
